function updateSetupInstructionsLinks(url) {
  document.querySelectorAll('[data-setup-instructions-link-block]').forEach((block) => {
    const wrapper = block.querySelector('[data-setup-instructions-link-wrapper]');
    const link = block.querySelector('[data-setup-instructions-link]');
    if (!wrapper || !link) return;
    if (url) {
      wrapper.removeAttribute('hidden');
      link.href = url;
    } else {
      wrapper.setAttribute('hidden', '');
      link.href = '#';
    }
  });

  const navLink = document.querySelector('[data-setup-instructions-nav-link]');
  if (navLink) {
    if (url) {
      navLink.removeAttribute('hidden');
      navLink.href = url;
    } else {
      navLink.setAttribute('hidden', '');
      navLink.href = '#';
    }
  }
}
